import styled from '@emotion/styled';
import { PricesTabType } from 'store/state/selectors/insights/prices';
import { PricesTableColumn } from '../../../utils';
import { SmallText } from 'ds/components/typography';

export const HistoryPricesColumn = styled.div<{ col?: PricesTableColumn, isExpanded?: boolean; type?: PricesTabType; isBulk?: boolean; isCompare?: boolean, isCurrent?: boolean}>`
  position: relative;
  ${({ isCompare, theme }) => isCompare ? `
    > a:hover > div {
      color: ${theme.colors.brand.main};
    }
  ` : ''}
  ${({ theme, col, isExpanded, type, isCurrent }) => theme.media.showAt({ to: 1 }) `
    ${isCurrent ? '' : `
      > a > div {
        text-decoration: underline;
      }
    `}
    ${col === PricesTableColumn.Price ? `
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      width: 100%;
      & > div:nth-of-type(2) {
        color: ${theme.colors.neutrals.grey3};
        text-align: ${theme.isRTL ? 'left' : 'right'};
        margin-top: 8px;
        flex-basis: 100%;
        white-space: initial;
      }
    ` : ''}
    ${col === PricesTableColumn.Date && isExpanded ? `
      & + div {
        position: absolute;
        top: 70px;
        left: 0;
        right: 0;
      }
    ` : ''}
    ${col === PricesTableColumn.Date && type && type !== PricesTabType.Unit ? `
      & > div:nth-of-type(2) {
        margin-top: 8px;
      }
    ` : ''}
  `}
  ${({ theme, col, isExpanded, type, isBulk }) => theme.media.showAt({ from: 2 }) `
    > a:hover > div {
      text-decoration: underline;
    }
    ${col === PricesTableColumn.Date ? `
      ${isExpanded ? `
        & + div {
          position: absolute;
          top: 50px;
          left: 0;
          right: 0;
          & > div:first-of-type:not(:last-of-type) {
            margin-bottom: 16px;
          }
        }
        ${type && type !== PricesTabType.Unit && isBulk ? `
          & + div {
            & > div:not(:first-of-type) {
              display: inline-flex;
              flex-wrap: wrap;
              width: 50%;
              & > div {
                flex-basis: 100%;
              }
            }
          }
        ` : `
          & + div {
            & > div:last-of-type {
              display: flex;
              flex-wrap: wrap;
              & > div {
                flex-basis: 50%;
              }
            }
          }
        `}
      ` : ''}
    ` : ''}
    ${col === PricesTableColumn.Action || col === PricesTableColumn.Address ? `
      width: 100%;
      & > div {
        white-space: nowrap;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    ` : ''}
  `}
  > a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.neutrals.grey1};
  }
`;

export const UnitExpendedLabel = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;

export const PricesContent = styled.div`
  display: flex;
  align-items: center;
`;

export const DateLabel = styled(SmallText)`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    color: ${theme.colors.neutrals.grey1};
    font-weight: bold;
  `}
`;

export const PriceLabel = styled(SmallText)`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    color: ${theme.colors.neutrals.grey1};
  `}
`;

export const AddressLabel = styled(SmallText)`
  ${({ theme }) => `
    color: ${theme.colors.brand.main};
    text-decoration: underline;
    unicode-bidi: embed;
    direction: ltr;
  `};
`;

export const DateColumnMobileWrapper = styled(SmallText)`
  ${({ theme }) => `
    width: calc(100vw - 110px);
    ${theme.isRTL ? 'right' :  'left'}: 0;
    word-break: break-word;
    white-space: normal;

    a, a > div {
      color: ${theme.colors.brand.main};
      text-decoration: underline;
      display: inline;
    }
  `}
`;

export const MobileLabelsWrapper = styled.span`
  ${({ theme }) => `
    white-space: nowrap;
    margin-bottom: ${theme.spacing(0.5)};
    display: inline-block;
  `}
`;


export const HistoryAddressLabel = styled(SmallText)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HistoryAddressLabelCell = styled.span`
  unicode-bidi: embed;
  direction: ltr;
`;
